import AuthContainer from './AuthContainer.component';

export default AuthContainer;
